import { Request } from "../request";

let num =1;

//关键词查询接口
export function keywordQuery(params) {
    return Request.http.post("/admin/search/keywordsSearchV1_2.html", params, num);
}

//年份-文章量接口
export function vintage_interface(params) {
    return Request.http.post("/admin/search/getYearsJournalNumsV1_2.html", params, num);
}

//频道列表接口
export function channelList(params) {
    return Request.http.post("/admin/search/getChannelListByCidV1_2.html", params, num);
}

//频道页内容搜索接口
export function ChannelPage(params) {
    return Request.http.post("/admin/search/channelSearchV1_2.html", params, num);
}

//高级搜索
export function advancedSearchInterface(params) {
    return Request.http.post("/admin/search/seniorSearchV1_2.html", params, num);
}

// 文章阅读量更新接口
export function readingNums(params) {
    return Request.http.post("/admin/article/updateReadNums.html", params, num);
}

// 微授权套餐列表
export function userComboList(params) {
    return Request.http.post("/admin/microAuth/userComboList", params, num);
}

// 授权主体列表
export function subjectListarr(params) {
    return Request.http.post("/admin/microAuth/subjectList", params, num);
}

// 添加／修改授权主体
export function editSubjectmet(params) {
    return Request.http.post("/admin/microAuth/editSubjectMsg", params, num);
}

// 删除授权主体接口
export function deleteSubjectMet(params) {
    return Request.http.post("/admin/microAuth/deleteSubjectMsg", params, num);
}

// 子账号列表
export function subAccountListmth(params) {
    return Request.http.post("/admin/microAuth/subAccountList", params, num);
}

// 点击申请加入
export function insertSubmth(params) {
    return Request.http.post("/admin/microAuth/insertSubAccount", params, num);
}

// 添加授权文章
export function addArticlemth(params) {
    return Request.http.post("/admin/microAuth/addArticle", params, num);
}

// 授权文章列表
export function authorizedArticlesList(params) {
    return Request.http.post("/admin/microAuth/articleList", params, num);
}

// 同意加入
export function agreedJoinMth(params) {
    return Request.http.post("/admin/microAuth/editSubAccount", params, num);
}

// 删除子账号
export function deleteSubAccountMth(params) {
    return Request.http.post("/admin/microAuth/deleteSubAccount", params, num);
}

// 确认待授权文章
export function confirmAuthArticmth(params) {
    return Request.http.post("/admin/microAuth/confirmAuthArticle", params, num);
}


// 删除待授权文章接口
export function deleteArtmth(params) {
    return Request.http.post("/admin/microAuth/deleteArticle", params, num);
}

// 转移管理员接口
export function changeAdminmth(params) {
    return Request.http.post("/admin/microAuth/changeAdmin", params, num);
}

// 已授权文章下载
export function downArticle(params) {
    return Request.http.post("/admin/microAuth/downArticle", params, num);
}

// 已授权文章合同下载
export function getAuthCertificateInfo(params) {
    return Request.http.post("/admin/microAuth/getAuthCertificateInfo", params, num);
}

// 企业信息
export function getCompanyInfo(params) {
    return Request.http.post("/admin/microAuth/getCompanyInfo", params, num);
}

// 子账号退出
export function exitSubAccount(params) {
    return Request.http.post("/admin/microAuth/exitSubAccount", params, num);
}


// WEBPACK FOOTER //
// ./src/api/lyl/index.js